import React from "react";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/material/styles";
import brand from "assets/images/mpi-logo.png";

const pulse = keyframes`
  0%   { transform: scale(0.92); opacity: 0.75; }
  50%  { transform: scale(1);    opacity: 1;    }
  100% { transform: scale(0.92); opacity: 0.75; }
`;

const spin = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const dots = keyframes`
  0%, 20%  { content: ""; }
  40%      { content: "."; }
  60%      { content: ".."; }
  80%, 100%{ content: "..."; }
`;

const PageLoader = () => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: 3,
      zIndex: (theme) => theme.zIndex.modal + 1,
      background: "linear-gradient(135deg, #F8F9FF 0%, #EEF1FB 100%)",
    }}
  >
    {/* Logo with spinning ring */}
    <Box sx={{ position: "relative", display: "grid", placeItems: "center" }}>
      <Box
        sx={{
          position: "absolute",
          width: 96,
          height: 96,
          borderRadius: "50%",
          border: "3px solid rgba(26, 35, 126, 0.12)",
          borderTopColor: "#1A237E",
          animation: `${spin} 0.9s linear infinite`,
        }}
      />
      <Box
        component="img"
        src={brand}
        alt="BIZOPS MPI"
        sx={{
          width: 56,
          height: 56,
          objectFit: "contain",
          animation: `${pulse} 1.6s ease-in-out infinite`,
        }}
      />
    </Box>

    {/* Brand + animated dots */}
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          fontWeight: 800,
          fontSize: "18px",
          letterSpacing: "1px",
          color: "#1A237E",
        }}
      >
        BIZOPS MPI
      </Box>
      <Box
        component="span"
        sx={{
          fontSize: "13px",
          color: "#757575",
          "&::after": {
            content: '""',
            animation: `${dots} 1.4s steps(1, end) infinite`,
          },
        }}
      >
        Memuat halaman
      </Box>
    </Box>
  </Box>
);

export default PageLoader;
